import { format_date, getDriverDisplayName, resolveImageUrl } from "../../Utils/helpers";
import "./RideDetailModals.css";

const formatPhone = (data) => {
  if (!data?.phone) return "N/A";
  if (data?.countryCode) {
    return `${data.countryCode}-${data.phone}`;
  }
  return data.phone;
};

const DetailField = ({ label, value, full, email }) => (
  <div className={`ride-detail-modal__field ${full ? "ride-detail-modal__field--full" : "ride-detail-modal__field--half"}`}>
    <span className="ride-detail-modal__label">{label}</span>
    <p className={`ride-detail-modal__value ${email ? "ride-detail-modal__value--email" : ""}`}>
      {value || "N/A"}
    </p>
  </div>
);

export default function DriverDetail({ data }) {
  const profileSrc = resolveImageUrl(data?.profileImage, "images/avatar.png");
  const fullName = getDriverDisplayName(data, "N/A");
  const completedDeliveries =
    data?.completedDeliveries ??
    data?.ridesCompleted ??
    data?.totalCompletedRides ??
    null;

  const licenseSrc =
    data?.licenseImageFront?.imageUrl ||
    data?.licenseImageBack?.imageUrl ||
    resolveImageUrl(data?.licenseImageFront || data?.licenseImageBack, "");

  return (
    <div
      className="modal fade ride-detail-modal"
      id="driverDetails"
      data-bs-backdrop="static"
      tabIndex="-1"
      aria-labelledby="driverDetailsTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="ride-detail-modal__inner">
            <div className="ride-detail-modal__header">
              <div>
                <h3 className="ride-detail-modal__title" id="driverDetailsTitle">
                  Driver Details
                </h3>
                <p className="ride-detail-modal__subtitle">Assigned driver for this ride</p>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="ride-detail-modal__hero">
              <img
                src={profileSrc}
                alt={fullName}
                className="ride-detail-modal__avatar"
                onError={(e) => {
                  e.currentTarget.src = "images/avatar.png";
                }}
              />
            </div>

            <div className="ride-detail-modal__grid">
              <DetailField label="Full Name" value={fullName} full />
              <DetailField label="Email Address" value={data?.email} full email />
              <DetailField label="Phone Number" value={formatPhone(data)} />
              <DetailField
                label="Date Registered"
                value={data?.createdAt ? format_date(data.createdAt, "DD/MM/YYYY") : "N/A"}
              />
              <DetailField
                label="Completed Deliveries"
                value={completedDeliveries != null ? String(completedDeliveries) : "N/A"}
                full
              />
            </div>

            {licenseSrc && (
              <div className="ride-detail-modal__license">
                <span className="ride-detail-modal__label">Driver License</span>
                <img src={licenseSrc} alt="Driver license" className="ride-detail-modal__license-img mt-2" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
